import { Result } from 'antd';
import React from 'react';

import PageWrapper from '@components/PageWrapper/PageWrapper';

// Port từ license-cms/source/src/containers/Forbidden.js.
// Nguồn: changeBreadcrumb([{ name: 'Bị cấm' }]) + <Result status="403" title="403" subTitle=... />
// Chuỗi i18n ForbiddenListPage: breadcrumbs.currentPage = 'Bị cấm'.
const ForbiddenPage = () => (
    <PageWrapper routes={[{ breadcrumbName: 'Bị cấm' }]}>
        <Result status="403" title="403" subTitle="Bạn không có quyền truy cập" />
    </PageWrapper>
);

export default ForbiddenPage;
